// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2b382ca4","453":"c3f6a82c","732":"6afc68cd"}[chunkId] + ".chunk.js";
};